// Word Unscrambler Tool — make words from scrambled letters (anagram solver).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const wordUnscramblerTool: Tool = {
  id: "word-unscrambler",
  name: () => m.wu_tool_name(),
  description: () => m.wu_tool_description(),
  icon: "🔡",
  basePath: "/word-unscrambler",
  status: "stable",
  tags: ["words", "unscramble", "anagram", "scrabble"],
  pages: [
    {
      name: () => m.wu_nav_main(),
      path: "/word-unscrambler",
      description: () => m.wu_nav_main_desc(),
      icon: "🔡",
    },
  ],
};
